/**
 * The directory pages' section title below md: Neue Haas at 1.5rem, medium
 * weight, tracked in to -0.02em. Recently viewed and Explore all categories
 * both take it, so the two read as one kind of head. Colour stays with each
 * section, which knows whether it sits on a dark theme.
 */
export const MOBILE_SECTION_TITLE =
    'max-md:font-sans max-md:text-6 max-md:leading-[1.2] max-md:font-medium max-md:tracking-[-0.02em]';
